// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".center-options[data-v-65ec4b8c] {\n  justify-content: center;\n}\n.disabled[data-v-65ec4b8c] {\n  color: gray;\n}", ""]);
// Exports
module.exports = exports;
